"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Link.scss");
const Link = _ref => {
  let {
    className,
    href,
    onClick,
    title,
    content,
    isDisabled,
    dataAttributes
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Dropdown-ListItemLink', {
    'cds-Link': !!href,
    'cds-Link--Disabled': !!href && isDisabled,
    'cds-ButtonLink': !href,
    'cds-ButtonLink--Disabled': !href && isDisabled
  }, className);
  const handleClick = e => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  if (content) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: rootClassName,
      onClick: handleClick
    }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), content);
  }
  if (!href) {
    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      className: rootClassName,
      onClick: handleClick,
      disabled: isDisabled
    }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), title || '');
  }
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    className: rootClassName,
    href: href,
    onClick: handleClick
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), title || '');
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map